<template>
    <div class="animated fadeIn unearnsettlefrm">        
        <b-card>
            <div slot="header">
                PBB (Payment Before Broadcast) Adjustment - Form
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>

            <b-row>
                <b-col lg="4" class="settlement-data">
                    <b-input-group >
                        <b-input-group-prepend><label>Adjustment Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.settleno" readonly></b-form-input>
                    </b-input-group>                        
                    <b-input-group >
                        <b-input-group-prepend><label>Adjustment Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.tglsettl" type="date" :state="!$v.model.tglsettl.$error"></b-form-input>                                        
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                            <b-form-textarea :rows="3" :max-rows="6" v-model="model.settleuraian" :state="!$v.model.settleuraian.$error" ></b-form-textarea>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Adjust. Account</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.glAccount"  :state="!$v.model.kodeacc.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCoaShow=true">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Adjusted Amount</label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span></b-input-group-prepend>
                        <my-number class="form-control text-right" separator="," v-model="model.totalpbb" :precision="2" disabled></my-number>
                    </b-input-group>

                </b-col>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Payment Number</label></b-input-group-prepend>
                                <b-form-input v-model="pbb.paymno" readonly></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuArsetShow=true">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>                        
                        </b-col>   
                        <b-col lg="5">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Payment Date</label></b-input-group-prepend>
                                <b-form-input v-model="pbb.tglpaym" type="date" disabled ></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-input-group >
                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-input  v-model="pbb.uraian" readonly></b-form-input>
                    </b-input-group>
                    <b-row>
                        <b-col lg="7">
                            <!-- <b-input-group>
                                <b-input-group-prepend><label>Receipt From</label></b-input-group-prepend>
                                <b-form-input readonly v-model="pbb.custinfo" ></b-form-input>
                            </b-input-group> -->
                            <b-input-group >
                                <b-input-group-prepend><label>Receipt From</label></b-input-group-prepend>
                                <b-form-input readonly v-model="pbb.custinfo" ></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuCustomerShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="5">      
                        <b-input-group>
                            <b-input-group-prepend class="d-md-inline d-lg-none"><label>Receive Method</label></b-input-group-prepend>
                            <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Receive Method</span></b-input-group-prepend>
                            <b-form-input readonly v-model="pbb.jenis" ></b-form-input>
                                <b-form-input v-model="pbb.nomorcek" readonly v-if="((pbb.jenis==='Cheque') || (pbb.jenis==='Giro'))"></b-form-input>
                        </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-row>
                        <b-col lg="8">
                            <b-input-group >
                                <b-input-group-prepend><label>Destination Bank</label></b-input-group-prepend>
                                <b-form-input readonly v-model="pbb.namabank"></b-form-input>
                                <b-input-group-append>
                                    <span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span>
                                </b-input-group-append>
                                <b-input-group-prepend class="d-md-inline d-lg-none"><label>Bank Account No.</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Bank Account#</span></b-input-group-prepend>
                                <b-form-input disabled v-model="pbb.nomorrek"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="4">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Efective Date</label></b-input-group-prepend>
                                <b-form-input v-model="pbb.tgl_terima" type="date" disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-row>
                        <b-col lg="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="pbb.totalbyr" :precision="2" disabled></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col lg="3">
                            <b-input-group >
                                <b-input-group-prepend><label>Bank Charges</label></b-input-group-prepend>
                                    <b-input-group-prepend class="d-md-inline d-lg-none"><span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="pbb.bcharges" :precision="2" disabled></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col lg="4">
                            <b-input-group v-if="(pbb.matauang !== uanguser)">
                                <b-input-group-prepend><label>Exch. Rate {{pbb.matauang || ''}}</label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{uanguser}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="pbb.kurstrx" :precision="6" disabled></my-number>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="5">
                            <b-input-group >
                                <b-input-group-prepend><label>PBB Amount</label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="pbb.pbb_amt" :precision="2" disabled></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col lg="4">
                            <b-input-group >
                                <b-input-group-prepend><span class="p-2">Settled</span></b-input-group-prepend>
                                    <b-input-group-prepend class="d-md-inline d-lg-none"><span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="pbb.pbb_sttl" :precision="2" disabled></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col lg="3">
                            <b-input-group >
                                <b-input-group-prepend><span class="p-2">Outsand</span></b-input-group-prepend>
                                    <b-input-group-prepend class="d-md-inline d-lg-none"><span class="input-group-text" style="width:70px;">{{pbb.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="pbb.pbb_ost" :precision="2" disabled></my-number>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-col>  
                    <b-input-group >
                        <b-input-group-prepend><label >iDocs Documents</label></b-input-group-prepend>
                        <b-input-group-prepend>
                                <span class="input-group-text" >PBB ADJUSTMENT</span>
                        </b-input-group-prepend>
                        <b-form-input v-model="model.iDocsURL" placeholder="iDocs URL"></b-form-input>
                        <b-input-group-append >
                            <b-btn text="Button" @click="show_iDocs()" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                        <b-input-group-append v-if="(model.iDocsURL)">
                            <b-btn text="Button" variant="success" @click="open_iDocs()" >
                                Open
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>

            </b-row>       

            <b-row class="justify-content-center mb-2">
                    <div style="width:450px;" class="text-right">
                        <b-input-group >
                            <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                            <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                            <b-input-group-append>
                                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                            </b-input-group-append>
                            <b-input-group-append>
                                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>

            </b-row>
        </b-card>
        <b-modal v-model="lkuArsetShow" size="lg" :hide-footer="true" title="List of Payment - with Unearned Income " :centered="true">
            <lku-arset @click="onSelectLkuArset" :formdata="lkuArsetData"></lku-arset>
        </b-modal>       
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        

    </div>
</template>
<style lang="scss">

    .input-group-prepend {
        label {
            padding-top: 5px;
            padding-right: 5px;
            width: 130px;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuArset from "../lookup/lkuArsetUnearn";
import lkuCoa from "../lookup/lkuCoa";
import lkuCustomer from "../lookup/lkuCustomer";
import arpbbadjust from '../../apis/arpbbadjust';
import { validationMixin } from "vuelidate";
import { required, requiredIf, requiredUnless, minValue, minLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim, lkuCoa,lkuArset, lkuCustomer},
  mixins: [validationMixin],
  validations: {
        model: {
            arpaymKey: { required },
            settleuraian: { required },
            tglsettl: { required },
            kodeacc: { required },
            settleamt: { required, minValue:minValue(0.01) },
            totalpbb: { required, minValue:minValue(0.00000001) }
        },
  }, 
  data() {
    return {
        arGroups : [],
        currency:[{value:'IDR',text:'IDR'}],
        potongans:[],
        saveEnabled:true,
        inputBerlanjut: 1,
        inputLineBerlanjut: 1,
        lkuCoaShow: false,
        lkuCustomerShow:false,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        model:{settleno:'',arpaymKey:'',glAccount:'', totalpbb:0,tglsettl:'',settleamt:0, kurstrx:1, settleuraian:'', custcode:'', customer_id:''},
        pbb:{jenis:'Giro',kodecash:'',kodebank:'',kurstrx:1,tglpaym:'',tgl_terima:'', matauang:'',totalbyr:'', custcode:'', customer_id:''},
        lblExchRate:"Exch. Rate ",
        bankOnly:1,
        totalDtlPaym:0,
        unsttlpbb: 0,
        updateDimHdr:false,
        updateDimDtl:true,
        lkuArsetShow:false,
        lkuArsetData:{},
        tabIndex:0
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    adaNilaiBank(){return ((this.arpaymdtObj.nilaibank || 0) != 0);},
  },
  watch: {
    IDPotongan: function(kode) {
        let pot = this.potongans.find(r => r.value===kode);
        if (pot){
            this.arpaymdtObj.Potongan=pot.text;
        }
    },    
  },
  created: async function(){
      this.model.matauang=this.uanguser;
      this.model.tglsettl = moment().format('YYYY-MM-DD');

      if (this.$route.params.settleKey) {
          toastr.info('Loading Payment Detail, please wait')
          try {
            const [a,c,d,data] = await Promise.all([arpbbadjust.currency(),await arpbbadjust.argroup(),await arpbbadjust.potongan(),
                                    arpbbadjust.detail(this.$route.params)]) ;
            this.currency = a;
            this.arGroups = c;
            this.potongans = d;
            const row = data[0][0];
            this.saveEnabled=(row.posting === 0);
        for (var key in row) {
            this.pbb[key] = row[key];
        }
        this.pbb.tglpaym = row.tglpaym ? moment(row.tglpaym).format('YYYY-MM-DD') : '';
        this.pbb.tgl_giro = (row.tgl_giro) ? moment(row.tgl_giro).format('YYYY-MM-DD') : '';
        this.pbb.tgl_terima = (row.tgl_terima) ? moment(row.tgl_terima).format('YYYY-MM-DD') : '';
        this.model.custcode = this.pbb.custcode;
        this.model.customer_id = this.pbb.customer_id;
        this.model.settleKey=row.settleKey;
        this.model.settleno = row.settleno;
        this.model.matauang = row.matauang;
        this.model.settleuraian=row.settleuraian;
        this.model.totalpbb=row.totalpbb;
        this.unsttlpbb= this.model.totalpbb;
        this.model.arpaymKey=row.arpaymKey;
        this.model.settleamt=row.settleamt;
        this.model.arpaymKey=row.arpaymKey;
        this.model.tglsettl = (row.tglsettl) ? moment(row.tglsettl).format('YYYY-MM-DD') : '';

            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        const [a,c,d] = await Promise.all([arpbbadjust.currency(),await arpbbadjust.argroup(),await arpbbadjust.potongan()]) ;
        this.currency = a;
        this.arGroups = c;
        this.potongans = d;
      }
  },
  methods: {
    async show_iDocs() {
        this.$show_iDocs({cat:6});
    },
    async open_iDocs() {
        this.$open_iDocs(this.model.iDocsURL, (state) => this.isLoading = state);
    },
    showLkuCoa(callerObj) {
        this.lkuCoaShow=true;
        this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        this.model.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.model.kodeacc = _selected.kodeacc;
        this.model.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    onSelectLkuArset: async function (arsetData) {
        for (var key in arsetData.selected) {
            this.pbb[key] = arsetData.selected[key];
        }
        this.pbb.tglpaym = arsetData.selected.tglpaym ? moment(arsetData.selected.tglpaym).format('YYYY-MM-DD') : '';
        this.pbb.tgl_giro = (arsetData.selected.tgl_giro) ? moment(arsetData.selected.tgl_giro).format('YYYY-MM-DD') : '';
        this.pbb.tgl_terima = (arsetData.selected.tgl_terima) ? moment(arsetData.selected.tgl_terima).format('YYYY-MM-DD') : '';
        this.model.custcode = this.pbb.custcode;
        this.model.customer_id = this.pbb.customer_id;
        this.model.kurstrx=1;
        this.model.matauang = arsetData.selected.matauang;
        this.model.settleuraian=arsetData.selected.uraian;
        this.model.totalpbb=arsetData.selected.pbb_ost;
        this.model.settleamt=arsetData.selected.pbb_ost;
        this.model.arpaymKey=arsetData.selected.arpaymKey;
        this.unsttlpbb= this.model.totalpbb;
        this.lkuArsetData=arsetData;

        this.lkuArsetShow=false;
    },
    onSelectLkuCustomer: async function (_selected) {
        this.pbb.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.custcode = _selected.CustCode;
        this.model.customer_id = _selected.customer_id;
        // const dim = this.dimension.find(d => d.RelatedObj=='customer');
        // if (dim) {
        //     this.model[`${dim.value}`] = _selected.CustCode;
        //     this.model[`${dim.value}Txt`] = _selected.CustName.trim();
        //     this.model[`${dim.value}Info`] = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        // }
        this.lkuCustomerShow=false;
    },

    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        this.model.kurstrx = this.pbb.kurstrx;
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else if (this.totalDtlPaym > parseFloat(this.model.totalpbb)) {
            toastr.error('[Total Detail Adjustment] is greater than [Unearned Inc. BALANCE]', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            try {
            // this.model.TableName = 'arsttltt';
            //     const dimValResult = await dimension.validate(this.model);
            //     if (dimValResult.success) {
                    this.model.settleno = this.model.settleno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.custcodeb4=this.pbb.custcode;
                    row.customer_idb4=this.pbb.customer_id;
                    row.tglsettl = moment(row.tglsettl).format('YYYY-MM-DD');

                    const hasil= await arpbbadjust.save(row);
                    toastr.success(`Success, Trx.Number ${hasil.settleno}`, "Save PBB Adjustment",10000);
                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.saveEnabled=true;            
                        // const jenis = this.model.jenis;
                        for (var key in this.model) {
                            this.model[key] = '';
                        }
                        // this.model.jenis = jenis;
                        // this.model.matauang= this.$store.state.user.matauang;
                        this.model.tglsettl = moment().format('YYYY-MM-DD');
                        this.$v.model.$reset();
                    }


                // } else {
                //     console.log('dimValResult : ', dimValResult);
                //     var msg = dimValResult.message || 'Dimension validation error';
                //     toastr.error(msg, "ERROR MESSAGE");
                // }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }

        }
    },
    closeArPayment: function(){
        const opened= this.arpaymdt.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name!=='receivable.pbbadjustfrm'))  {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'receivable.pbbadjust'});
      }
    }
  }
};
</script>
